import { GridColDef } from "@mui/x-data-grid";
import { Button, IconButton } from "@mui/material";

import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";

/**
 * GeneratePatrimonioInspecaoCadastroColumnDefinition
 */

type Props = {
  onEnterChecklists: (idPatrimonioMaquinaEquip: number, openNewTab: boolean) => void;
  onActionEditar: (idPatrimonioMaquinaEquip: number | null, openState: boolean) => void;
  onActionDeletar: (idPatrimonioMaquinaEquip: number | null, openState: boolean) => void;
  // onActionCopiar: (idPatrimonioMaquinaEquip: number | null, openState: boolean) => void;
};

export const GeneratePatrimonioInspecaoCadastroColumnDefinition = ({
  onEnterChecklists,
  onActionEditar,
  onActionDeletar,
  // onActionCopiar,
}: Props): GridColDef[] => {
  const computeItemStatusTitle = (status: number) => {
    switch (status) {
      case 0:
        return "Em aberto";
      case 1:
        return "Finalizada";
      default:
        return "?";
    }
  };

  const computeItemStatusColor = (status: number) => {
    switch (status) {
      case 0:
        return "yellow";
      case 1:
        return "red";
      default:
        return "blue";
    }
  };

  const computeItemStatusDescription = (status: number) => {
    switch (status) {
      case 0:
        return "Em aberto";
      case 1:
        return "Finalizada";
      default:
        return "?";
    }
  };

  return [
    {
      field: "status",
      filterable: false,
      headerName: "Status",
      minWidth: 90,
      width: 90,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex justify-center items-center">
          <ItemStatus
            size="autowidth"
            textSize="small"
            title={computeItemStatusTitle(params.value)}
            color={computeItemStatusColor(params.value)}
            description={computeItemStatusDescription(params.value)} />
        </div>
      )
    },
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 300,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => (
        <div className="w-full h-full flex justify-start items-center break-normal">
          {value ?? ""}
        </div>
      ),
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Checklist",
      sortable: false,
      flex: 1,
      minWidth: 200,
      valueGetter: (_, row) => {
        return {
          idPatrimonioMaquinaEquip: row['idPatrimonioMaquinaEquip'] as number,
          nomeChecklist: row['nomeChecklist'] as string | null,
        };
      },
      renderCell: ({ value }) => {
        return (
          <Button
            onMouseDown={(e) => {
              if (e.button === 1) {
                onEnterChecklists(value.idPatrimonioMaquinaEquip, true);
              } else {
                onEnterChecklists(value.idPatrimonioMaquinaEquip, e.ctrlKey);
              }
              e.preventDefault();
            }}
            sx={{
              fontSize: 11,
              paddingX: '.4rem',
              paddingY: 0,
              background: '#e6e6e6',
              borderLeft: '.2rem solid #8e44ad',
              borderRadius: 0,
              color: 'black',
              fontWeight: 'normal',
            }}>
            {value.nomeChecklist ?? " - "}
          </Button>
        );
      },
    },
    {
      field: "ia",
      filterable: false,
      headerName: "I.A",
      minWidth: 50,
      align: 'center',
      sortable: false,
      headerClassName: 'ia-header',
      renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
    },
    {
      field: "ir",
      filterable: false,
      headerName: "I.R",
      minWidth: 50,
      align: 'center',
      sortable: false,
      headerClassName: 'ir-header',
      renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
    },
    {
      field: "ira",
      filterable: false,
      headerName: "I.RA",
      minWidth: 50,
      align: 'center',
      sortable: false,
      headerClassName: 'ira-header',
      renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
    },
    {
      field: "ix",
      filterable: false,
      headerName: "I.REP",
      minWidth: 50,
      align: 'center',
      sortable: false,
      headerClassName: 'ix-header',
      renderCell: ({ value }) => (<div>{typeof value === 'number' && `${(value * 100).toFixed(2)} %`}</div>),
    },
    {
      field: 'idPatrimonioMaquinaEquip',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={false}
              onMouseDown={e => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton
              disabled={false}
              onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
    // {
    //   field: 'copiar',
    //   sortable: false,
    //   filterable: false,
    //   headerName: 'Copiar',
    //   width: 65,
    //   resizable: false,
    //   valueGetter: (_, row) => row['idObraAreaChecklist'] as number,
    //   renderCell: (params) => {
    //     return (
    //       <div className="flex items-center justify-center w-full h-full gap-2">
    //         <IconButton
    //           disabled={obraStatus !== 0}
    //           onClick={() => onActionCopiar(params.value, true)}>
    //           <DynamicIcon nameIcon="ContentCopy" size={25} className="text-purple-500" />
    //         </IconButton>
    //       </div>
    //     );
    //   }
    // },

  ];
}